import { Component } from '@angular/core';

import { Globals } from 'src/app/wings-mobile/shared/globals/globals';
import { NgIf } from '@angular/common';

@Component({
    selector: 'footer-template',
    templateUrl: './footer-template.component.html',
    styleUrls: ['./footer-template.component.scss'],
    imports: [NgIf]
})
export class FooterTemplateComponent {

	actualYear: number = new Date().getFullYear();

	constructor(public globals: Globals) {
		this.globals = globals;
	}
}

